import { NavLink } from 'react-router-dom';
import { ReactElement } from 'react';
import styles from './Link.module.scss';

interface LinkProps {
  to: string;
  title: string;
}

export const Link = ({ to, title }: LinkProps): ReactElement => {
  return (
    <NavLink className={styles.link} to={to}>
      {title}
    </NavLink>
  );
};

export default Link;
